import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ManagerSchedulePageRoutingModule } from './manager-schedule-routing.module';

import { ManagerSchedulePage } from './manager-schedule.page';
import { TranslateModule } from '@ngx-translate/core';
import { SharedDirectivesModule } from 'src/app/directives/shared-directives.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule.forChild(),
    IonicModule,
    SharedDirectivesModule,
    ManagerSchedulePageRoutingModule
  ],
  declarations: [ManagerSchedulePage]
})
export class ManagerSchedulePageModule {}
